/** "$500" for whole-dollar amounts, "$12.50" otherwise. */
export const formatUsd = (cents: number, currency = 'usd'): string => {
  const dollars = cents / 100;
  const whole = Number.isInteger(dollars);
  return dollars.toLocaleString(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: 2,
  });
};

export const formatCredits = (credits: number): string =>
  Math.max(0, Math.floor(credits)).toLocaleString();
